const fareNibi = 0.06;
const feePasarela = 600;
const comisionPasarela = 0.015;
const retencionFuente = 0.015;
const retencionICA = 0.002;
const iva = 0.19;
const totalIva = 1 + iva;
const retencionIVA = 0;

export function getTotalAmount(targetAmount, paymentMethod) {

  if (paymentMethod === 'DESCUENTO_NOMINA') return Math.ceil(targetAmount / (1 - fareNibi));

  const retFuente = paymentMethod === 'CARD' ? retencionFuente : 0;
  const retICA = paymentMethod === 'CARD' ? retencionICA : 0;
  const amount = (targetAmount + (totalIva * feePasarela)) / (1 - ((totalIva * comisionPasarela) + retFuente + retICA + retencionIVA + fareNibi));

  return Math.ceil(amount);
}

export function getTotalAmountInfo(targetAmount, paymentMethod) {
  const amount = getTotalAmount(targetAmount, paymentMethod);

  if (paymentMethod === 'DESCUENTO_NOMINA') return { total: amount, totalDiscounted: amount - targetAmount };

  const retFuente = paymentMethod === 'CARD' ? retencionFuente : 0;
  const retICA = paymentMethod === 'CARD' ? retencionICA : 0;  
  const comisionPasarelaAmount = comisionPasarela * amount;

  const info = [
    { name: 'Monto de donación', amount: targetAmount},
    { name: 'Monto pasarela de pagos', amount: feePasarela },
    { name: 'Comisión nibi', amount: fareNibi * amount },
    { name: 'Comisión pasarela de pagos', amount: comisionPasarelaAmount },
    { name: 'Retención fuente', amount: retFuente * amount },
    { name: 'Retención ICA', amount: retICA * amount },
    { name: 'IVA', amount: (feePasarela + comisionPasarelaAmount) * iva },
    { name: 'TOTAL', amount }
  ];

  return { info, total: amount, totalDiscounted: amount - targetAmount };
}
